import React from 'react';
import styled from '@emotion/styled';
import { keyframes } from 'styled-components';
import { css } from '@emotion/core';
import { fontSize } from '../../../constants';

export const FlexContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  padding-top: 30px;
  width: 100%;
`;

export const Container = styled.div`
  height: 270px;
  width: 80%;
  border-bottom: ${({ theme }) => `1px solid ${theme.colors.greyLight}`};
  border-radius: 4px;
  box-shadow: 0px 1px 7px 0 rgba(0, 105, 250, 0.15);
  z-index: 10;
  background-color: ${({ theme }) => theme.colors.whiteBackground};
  @media screen and (max-width: 576px), (max-width: 768px) {
    width: 80%;
    height: 410px;
  }
  @media screen and (min-width: 1920px) {
    width: 80%;
  }
`;

export const StatusContainer = styled.div`
  margin-top: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  @media screen and (max-width: 576px), (max-width: 768px) {
    margin-top: 90px;
  }
`;

export const Title = styled.div`
  margin: 20px 10px 0 0;
  text-align: center;
  font-size: 25px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.33;
  letter-spacing: normal;
  color: #0070ba;
`;

export const SubTitle = styled.div`
  text-align: center;
  font-family: 'Heebo-Light';
  font-size: 14px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.33;
  letter-spacing: normal;
  text-align: center;
  color: #233b69;
  margin-bottom: 45px;
`;

export const AddressTitle = styled.div`
  font-size: 17px;
  font-weight: normal;
  font-stretch: normal;
  text-align: center;
  font-style: normal;
  line-height: 1.33;
  letter-spacing: normal;
  color: #000;
`;

export const AddressContent = styled.div`
  font-family: 'Heebo-Light';
  font-size: 14px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.33;
  letter-spacing: normal;
  text-align: center;
  color: #233b69;
`;

export const TimelineSpacer = styled.div`
  height: 0px;
  border-bottom: 1px solid
    ${({ green, theme }) => (green ? theme.colors.greenBright : theme.colors.greyMid)};
  width: ${({ width }) => width || 'auto'};
`;

const GreenDotAnimation = keyframes`
0% { transform: scale(0.95);
    box-shadow: 0 0 0 0 rgba(51, 217, 178, 0.7);
    }
70% { transform: scale(1);
    box-shadow: 0 0 0 10px rgba(51, 217, 178, 0);
    }
100% {
    transform: scale(0.95);
    box-shadow: 0 0 0 0 rgba(51, 217, 178, 0);
    }
`;

const TimelineStartDot = styled.div`
  border-width: 1px;
  background-color: ${({ theme }) => theme.colors.whiteLightBackground};
  border-style: solid;
  animation: ${({ green }) => green && `${GreenDotAnimation} 2s infinite;`};
  ${({ margin }) => (margin ? `margin: ${margin}` : '')};
  ${({ green, theme, uneven }) =>
    green
      ? `
    width: 21px;
    min-height: 21px;
    border-radius: 10.5px;
    border-color: ${theme.colors.greenBright};
    background: radial-gradient(
      circle,
      ${theme.colors.greenBright} 0,
      ${theme.colors.greenBright} 6px,
      ${theme.colors.whiteLightBackground} 7px
    );
    margin: ${uneven ? '-10px 0 0 0' : '0 0 -10px 0'};
  `
      : `
    width: 18px;
    min-height: 18px;
    border-radius: 9px;
    border-color: ${theme.colors.greyMid};
    margin: ${uneven ? '-9px 0 0 0' : '0 0 -9px 0'};
    background: radial-gradient(
      circle,
      ${theme.colors.greyMid} 0,
      ${theme.colors.greyMid} 5px,
      ${theme.colors.whiteLightBackground} 6px
    );
  `}
`;

const TimelineBar = styled.div`
  width: 1px;
  ${({ green, theme }) =>
    green
      ? `
    min-height: 21px;
    background: ${theme.colors.greenBright};
  `
      : `
    min-height: 22px;
    background: ${theme.colors.greyMid};
  `}
`;

const TimelineEndDot = styled.div`
  min-height: 5px;
  width: 5px;
  border-radius: 2.5px;
  ${({ margin }) => (margin ? `margin: ${margin}` : '')};
  ${({ green, theme }) =>
    green
      ? `
    background: ${theme.colors.greenBright};
  `
      : `
    background: ${theme.colors.greyMid};
  `}
`;

export const TrackingInfoStatusStep = ({ index, currentStep, title }) => {
  const uneven = !!(index % 2);
  return (
    <div
      css={css`
        width: 0;
        height: 0;
        display: flex;
        align-items: center;
        z-index: 1;
        flex-direction: ${uneven ? 'column' : 'column-reverse'};
      `}
    >
      <React.Fragment>
        <TimelineStartDot green={currentStep} uneven={uneven} />
        <TimelineBar green={currentStep} />
        <TimelineEndDot green={currentStep} />
      </React.Fragment>

      <div
        css={css`
          text-align: left;
          white-space: pre;
          font-size: 9px;
          ${!uneven && index !== 0 && 'margin-bottom: 10px;'}
          ${uneven && 'margin-top: 10px;'}
          &::first-line {
            font-weight: bold;
            font-size: ${fontSize.small};
          }
        `}
      >
        {title}
        {'\n'}
      </div>
    </div>
  );
};
